import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CryptoService {
  async encryptAES(plaintext: string): Promise<string> {
    console.log('****** plaintext ******', plaintext);

    if (plaintext == undefined || plaintext == null || plaintext == '') {
      return '';
    }

    const hashedKey = CryptoJS.MD5(environment.requestEncryptKey);

    const encrypted = CryptoJS.AES.encrypt(
      plaintext,
      hashedKey,
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      }
    );
    console.log('****** encrypted ******', encrypted.toString());
    return encrypted.toString();
  }

  // Provided decryption function, included for completeness
  async decryptAES(data: string): Promise<string> {
    const hashedKey = CryptoJS.MD5(environment.requestEncryptKey);

    const decrypted = CryptoJS.AES.decrypt(
      data,
      hashedKey,
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      }
    );

    const plaintext = decrypted.toString(CryptoJS.enc.Utf8);
    return plaintext;
  }
}